import httpRequest from "@/auth/http-client";

class CampaignScheduleService {
  private baseUrl = "api/v1/campaignschedule";

  async delete(scheduleId: number): Promise<void> {
    await httpRequest.delete(`${this.baseUrl}/${scheduleId}`);
  }
}

const campaignScheduleService = new CampaignScheduleService();
export default campaignScheduleService;
